import { Component, OnInit, OnDestroy, ViewEncapsulation, ElementRef, } from '@angular/core';
import { FuseConfigService } from '@fuse/services/config.service';
import { lang_conteos } from 'app/idiomas/i18n/Conteos/conteos.lang';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { ConteosService } from 'app/main/wizard-cgo/services/conteos.service';
import { CierreService } from 'app/main/wizard-cgo/services/cierre.service';
import * as backInter from 'app/auth/auth-data.model';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { ActivatedRoute } from '@angular/router';
import { DATOS_API } from 'app/auth/auth.datos';
import { takeUntil } from 'rxjs/operators';

import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
////graficas
import {ViewChild } from '@angular/core';
import { ChartDataSets, ChartOptions,ChartType } from 'chart.js';
import { Color, BaseChartDirective, Label } from 'ng2-charts';
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {Subscription,Subject} from 'rxjs';
import { fuseAnimations } from '@fuse/animations';

const moment = require('moment');
const momentTz = require('moment-timezone');
import { DatePipe } from '@angular/common';
import * as html2canvas from 'html2canvas';
export interface filtrosPortalConteosV2{
  COLABORADORES_QUE_AUN_NO_RESPONDEN: number,
  COLABORADORES_QUE_YA_RESPONDIERON: number,
  FILTRO: string,
  Nivel_1: string,
  Nivel_2: string,
  PROGRESO_TOTAL: number,
  SEGMENTO: string,
  TOTAL_DE_COLABORADORES: number
}

export interface filtrosPortalConteosV2Reducido{
  COLABORADORES_QUE_AUN_NO_RESPONDEN: number,
  COLABORADORES_QUE_YA_RESPONDIERON: number,
  FILTRO: string,
  PROGRESO_TOTAL: number,
  SEGMENTO: string,
  TOTAL_DE_COLABORADORES: number
}

@Component({
  selector: 'app-portal-conteos',
  templateUrl: './portal-conteos.component.html',
  styleUrls: ['./portal-conteos.component.scss'],
  animations   : fuseAnimations,
})
export class PortalConteosComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns: string[] = ['nivel1', 'nivel2', 'demografico', 'segmento', 'colaboradoresTotales', 'pendientesResponder', 'respondieron', 'avance'];
  filtroPortalv2: MatTableDataSource<backInter.filtrosPortalConteosV2>;
  datosTablaFiltro:backInter.filtrosPortalConteosV2;

  displayedColumnsReducido: string[] = ['demografico', 'segmento', 'colaboradoresTotales', 'pendientesResponder', 'respondieron', 'avance'];
  filtroPortalv2Reducido: MatTableDataSource<backInter.filtrosPortalConteosV2Reducido>;
  datosTablaFiltroReducido:backInter.filtrosPortalConteosV2Reducido;

  mensaje=false;
  urlImagenLog= DATOS_API.urlAssets;
  cargandoFiltros=false;
  valorMayor:number;
  datosEncontrados: boolean;
   bubbleChartOptions: ChartOptions;
   barChartLabels=["2006", "2007", "2008", "2009", "2010", "2011", "2012"];

 public bubbleChartType: ChartType = 'bubble';
 public bubbleChartLegend = true;
 public bubbleChartData: ChartDataSets[] = [
  {
    data: [
      { x: 10, y: 10, r: 6 },
      { x: 15, y: 5, r: 6 },
      { x: 26, y: 12, r: 6 },
      { x: 7, y: 8, r: 6 },
    ],
     label: '',
     backgroundColor: 'green',
     borderColor: 'blue',
     hoverBackgroundColor: 'purple',
     hoverBorderColor: 'red',
   },
 ];

 public bubbleChartColors: Color[] = [
   {
     backgroundColor: [

       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',
       '#2E86C1',


     ]
   }
 ];
 mensajesTraducirKeys: string[] = [
   'CERTIFICAR.COLABORADORES.MENSAJES.GUARDA_1',
   'CERTIFICAR.COLABORADORES.MENSAJES.GUARDA_2',
   'CERTIFICAR.COLABORADORES.MENSAJES.GUARDADO',
   'CERTIFICAR.COLABORADORES.MENSAJES.GUA_ERR',
   'CERTIFICAR.COLABORADORES.MENSAJES.DELETE_1',
   'CERTIFICAR.COLABORADORES.MENSAJES.DELETE_2',
   'CERTIFICAR.COLABORADORES.MENSAJES.DEL_OK_1',
   'CERTIFICAR.COLABORADORES.MENSAJES.DEL_OK_2',
   'CERTIFICAR.COLABORADORES.MENSAJES.DEL_ERR',
   'CERTIFICAR.COLABORADORES.MENSAJES.DELFILE',
   'CERTIFICAR.COLABORADORES.MENSAJES.EXCEL',
   'CERTIFICAR.COLABORADORES.MENSAJES.EXTMAL',
   'CERTIFICAR.COLABORADORES.MENSAJES.NOROWS',
   'CERTIFICAR.COLABORADORES.MENSAJES.VACIO',
   'CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.SI',
   'CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.NO',
   'CERTIFICAR.COLABORADORES.EXCELINFO.HOJA',
   'CERTIFICAR.COLABORADORES.EXCELINFO.TITULO',
   'CERTIFICAR.COLABORADORES.EXCELINFO.AUTOR',
   'CERTIFICAR.COLABORADORES.EXCELINFO.ASUNTO',
   'CERTIFICAR.IDIOMAS.MENSAJES.ERRORDEL',
   'PORTAL.EXCEL.NOMEMPRE',
   'PORTAL.EXCEL.NOMUSUARIO',
   'PORTAL.EXCEL.NOMPROD',
   'PORTAL.EXCEL.FECHLANZA',
   'PORTAL.EXCEL.FECHDESCA',
   'PORTAL.EXCEL.DRESTAN',
   'PORTAL.EXCEL.TOTALCOLA',
   'PORTAL.EXCEL.TOTALFAL',
   'PORTAL.EXCEL.TOTALCONT',
   'PORTAL.EXCEL.TOTALPRO',
   'PORTAL.EXCEL.REPORTE',
   'PORTAL.EXCEL.FILT',
   'PORTAL.EXCEL.RANKING',
   'PORTAL.EXCEL.NOMFILT',
   'PORTAL.EXCEL.INFOGENE',
   'PORTAL.EXCEL.FILTROSNAME',


   ];

   // graficaLineal
   public lineChartType: ChartType = 'line';
   public lineChartLegend  = true;
   public lineChartLabels: Label[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
   lineChartOptions: ChartOptions;
   public lineChartData: ChartDataSets[] = [
     {
     data: [65, 59, 80, 81, 56, 55, 40],
       label: '',
       // // backgroundColor: '#2E86C1',
       // borderColor: '#2E86C1',
       // hoverBackgroundColor: '#2E86C1',
       // // hoverBorderColor: 'red',
       // pointStyle:'circle',
       // pointRadius: 10,
       // backgroundColor: 'transparent',
       // lineTension: 0,
       // fill: false,
       lineTension: 0,
       fill: false,
       borderColor: 'orange',
       backgroundColor: 'transparent',
       borderDash: [5, 5],
       pointBorderColor: 'orange',
       pointBackgroundColor: 'rgba(255,150,0,0.5)',
       pointRadius: 10,
       pointHoverRadius: 15,
       pointHitRadius: 30,
       pointBorderWidth: 2,
       pointStyle: 'rectRounded'
     },
   ];

   public lineChartColors: Color[] = [
     {
       // backgroundColor: ['#2E86C1',
       //   ]
     }
   ];





 //variables que tomaran las traducciones indicadas en la variable anterior
 //deben ir en el mismo orden
 mensajesTraducirTS = {
   guarda_1: '',
   guarda_2: '',
   guardado: '',
   gua_err: '',
   delete_1: '',
   delete_2: '',
   del_ok_1: '',
   del_ok_2: '',
   del_err: '',
   delfile: '',
   excel: '',
   extmal: '',
   norows: '',
   vacio: '',
   si: '',
   no: '',
   hoja: '',
   titulo: '',
   autor: '',
   asunto: '',
   errDel: '',
   nomempre:'',
   nomusuario:'',
   nomprod:'',
   fechlanza:'',
   fechdesca:'',
   drestan:'',
   totalcola:'',
   totalfal:'',
   totalcont:'',
   totalpro:'',
   reporte:'',
   ranking:'',
   filt:'',
   nomfilt:'',
   infogene:'',
   filtrosname:'',
 };
  fechaLanzamiento: "10/23/10";////prueba
  diasRestantes=5;
  nombreEmpresaFinal: string;
  usuarioEmpresaFinal:string;
  tipoProductoFinal:string;
  fechaProducto:string;
  tipoProducto: string;
  encuestaID: string;
  urlProducto:string;
  nombre:string;
  idFiltro: number;
  listaFiltros: backInter.listaFiltros[] = [];
  conteosClaves: backInter.getConteosClave;
  conteosClaves2Empresa: backInter.getConteosClave;
  resultadoConteo: backInter.getConteosFiltros;
  resultadoConteo2Empresa: backInter.getConteosFiltros;
  timeLineGraficaCer: backInter.timeLineGraficaCertificar;
  claveConteos:string;
  statusNorma=false;
  linkValido=true;
  msjAlertClosPortal=false;
  totalUsers:number;
  fechaClave:string;
  diasCaducidad: number;
  endUsers:number;
  styleElement: HTMLStyleElement;
  porcentajeUsers="0.00";
    fxFlexEspacio=33;
    sumaFormula1: number;
    sumaFormula2:number;
    resultadoRanking: number;
    selectInstituto:number;
    validarIzzi:boolean=false;
  ///variables para el caso de las 2 empresas
   claveAccesoEmpresa2:string;
   unaEmpresa:boolean=true;
   totalColaboradores2Empresas: number;
   totalColaboradoresFaltantes2Empresas: number;
   totalColaboradoresFinalizaron2Empresas: number;
   totalPorcentaje2Empresas: number;
   filtrados2empresas: any[]=[];
   filtrados2empresas2: any[]= [];
   timeLine2empresas: any[]= [];
   tipoPersonalSeleccionado=1;
   tipoPersonal: any[] = [
    {value: 1},
    {value: 2},
    {value: 3},
  ];
empresasExisten2:boolean=false;
empresasBaxter:boolean=false;

    tokenConfiguration:any;
    cargandoTablaFiltros:boolean=true;
    checked:boolean=false;
    selected:string[]=[];
    selectedSegmentos:string[]=[];
    selectedNivel1:string[]=[];
    selectedNivel2:string[]=[];
    catalogoFiltros:string[]=[];
    catalogoFiltrosSegmento:string[]=[];
    catalogoFiltrosN1:string[]=[];
    catalogoFiltrosN2:string[]=[];
    filtrosExcelV2:any;
    visualizarCards:boolean=false;
    filteredValues = {
      Nivel_1: '', Nivel_2: '', FILTRO: '',
      SEGMENTO: ''
    };

    catalogoFiltroSeccionN_1:string[]=[];
    catalogoFiltroSeccionN_2:string[]=[];
    catalogoFiltroSeccionDemografico:string[]=[];
    catalogoFiltroSeccionSegmento:string[]=[];

    variableReservaN_1:string[]=[];
    variableReservaN_2:string[]=[];
    variableReservaDemografico:string[]=[];
    variableReservaSegmento:string[]=[];

    validacionNivel_1:boolean=false;
    validacionNivel_2:boolean=false;
    validacionDemografico:boolean=false;
    validacionSegmento:boolean=false;

    portalValidacion:boolean=false;

    checkedReducido:boolean=false;
    selectedReducido:string[]=[];
    selectedSegmentosReducido:string[]=[];
    selectedNivel1Reducido:string[]=[];
    selectedNivel2Reducido:string[]=[];
    catalogoFiltrosReducido:string[]=[];
    catalogoFiltrosSegmentoReducido:string[]=[];
    filtrosExcelV2Reducido:any;
    filteredValuesReducido = {
      FILTRO: '', SEGMENTO: ''
    };

    catalogoFiltroSeccionDemograficoReducido:string[]=[];
    catalogoFiltroSeccionSegmentoReducido:string[]=[];
    variableReservaDemograficoReducido:string[]=[];
    variableReservaSegmentoReducido:string[]=[];
    validacionDemograficoReducido:boolean=false;
    validacionSegmentoReducido:boolean=false;

    fechaAnterior:boolean=false;
    resultsBoxEntregables:boolean;
    resultsBoxRanking:boolean;
    textResultsBoxEntregables:any;
    textResultsBoxRanking:any;
    textToolResultsBoxEntregables:any;
    textToolResultsBoxRanking:any;
 idProductoCertificares:any;
 respRecRes:any;
 respMinCer:any;
 fuseConfig: any;
 form = this._formBuilder.group({
   colorTheme      : new FormControl(),
   customScrollbars: new FormControl(),
   layout          : this._formBuilder.group({
     style    : new FormControl(),
     width    : new FormControl(),
     navbar   : this._formBuilder.group({
       primaryBackground  : new FormControl(),
       secondaryBackground: new FormControl(),
       folded             : new FormControl(),
       hidden             : new FormControl(),
       position           : new FormControl(),
       variant            : new FormControl()
     }),
     toolbar  : this._formBuilder.group({
       background           : new FormControl(),
       customBackgroundColor: new FormControl(),
       hidden               : new FormControl(),
       position             : new FormControl()
     }),
     footer   : this._formBuilder.group({
       background           : new FormControl(),
       customBackgroundColor: new FormControl(),
       hidden               : new FormControl(),
       position             : new FormControl()
     }),
     sidepanel: this._formBuilder.group({
       hidden  : new FormControl(),
       position: new FormControl()
     })
   })
 });
 private _unsubscribeAll: Subject<any>;
 parametroTema: string;
 indiceZona: number;
 diferenciaUtc: number;
 offsetPipe: string;
 zonasUTC = [
   {instituto: 0, zona: 'Etc/Greenwich', ciudad:''},
   {instituto: 1, zona: 'America/Mexico_City', ciudad:'Ciudad de México'},  //instituto MX
   {instituto: 2, zona: 'America/El_Salvador', ciudad:''},  //instituto CAyC
   {instituto: 3, zona: 'Hongkong', ciudad:''}, //instituto HK
   {instituto: 4, zona: 'Hongkong', ciudad:''}, //instituto SGP
   {instituto: 5, zona: 'Turkey', ciudad:''}, //instituto TK
   {instituto: 6, zona: 'Hongkong', ciudad:''}, //instituto FL
   {instituto: 8, zona: 'America/Mexico_City', ciudad:'Ciudad de México'},  //instituto MX
   {instituto: 11, zona: 'Brazil/East', ciudad:''}, //instituto BR
   {instituto: 14, zona: 'America/Mexico_City', ciudad:'Ciudad de México'}, //instituto gcti
   {instituto: 15, zona: 'Europe/Madrid', ciudad:'Madrid'}, //instituto ES
   {instituto: 19, zona: 'America/Mexico_City', ciudad:'Ciudad de México'},
   {instituto: 21, zona: 'America/Mexico_City', ciudad:'Ciudad de México'},
 ];
 idiomaActual:string;

  @ViewChild('screen') screen: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  @ViewChild('downloadLink') downloadLink: ElementRef;

  constructor(
    private activatedRoute : ActivatedRoute,
    private _fuseConfigService: FuseConfigService,
    private cierreService: CierreService,
    private conteosService: ConteosService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private _formBuilder: FormBuilder,
    private datePipe: DatePipe,
    ) {
      this.activatedRoute.params.subscribe(params => {
        this.claveConteos = params['id'];
        // console.log(this.claveConteos);
        if(params['lang'] != undefined){
          this.translateSrv.use(params['lang']);
        }
      });
      this._fuseConfigService.config = {
          layout: {
              navbar   : {hidden: true},
              toolbar  : {hidden: false},
              footer   : {hidden: true},
              sidepanel: {hidden: true},

          }
      };
      lang_conteos.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
     this.translateSrv.onLangChange.subscribe(() => {  if(this.idFiltro )this.translateSrv.get('PORTAL.FILTROS.'+this.idFiltro).subscribe((res1: string) => { this.nombre = res1; });
    });
     this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS();this.obtenerInfoCambioIdioma();});

     if(localStorage.getItem('tipoIzzi')){
       this.validarIzzi = true;
     }

    }


  ngOnInit() {



    if(this.claveConteos=="5f3444c3b13f6a4c17ffd07c" || this.claveConteos== "5f342898b13f6a4c17ff8031"){
      console.log("coincide");
      this.empresasBaxter=false;
      this.empresasExisten2=true;
        if(this.claveConteos=="5f3444c3b13f6a4c17ffd07c"){
        this.claveAccesoEmpresa2="5f342898b13f6a4c17ff8031";
        console.log(this.claveAccesoEmpresa2);

      }else if(this.claveConteos== "5f342898b13f6a4c17ff8031"){
        this.claveAccesoEmpresa2="5f3444c3b13f6a4c17ffd07c";
        console.log(this.claveAccesoEmpresa2);
      }
      this.styleElement = document.createElement('style');
      this.cambiaColorProgress();
      this.getConteosClaves();
    }
    else if(this.claveConteos=="5f4fdb80546e07088043715f" || this.claveConteos== "5f511dd0d7b2b124ef401a17"){

    console.log("coincide con los de la empresa Baxter");
    this.empresasExisten2=false;
    this.empresasBaxter=true;
      if(this.claveConteos=="5f4fdb80546e07088043715f"){
      this.claveAccesoEmpresa2="5f511dd0d7b2b124ef401a17";
      console.log(this.claveAccesoEmpresa2);

    }else if(this.claveConteos== "5f511dd0d7b2b124ef401a17"){
      this.claveAccesoEmpresa2="5f4fdb80546e07088043715f";
      console.log(this.claveAccesoEmpresa2);
    }
    this.styleElement = document.createElement('style');
    this.cambiaColorProgress();
    this.getConteosClavesVersion2();


    }
    else{
      console.log("No coincide");
       this.empresasBaxter=false;
      this.styleElement = document.createElement('style');
      this.cambiaColorProgress();
      this.getConteosClaves();
      this.unaEmpresa=true;
      console.log(this.unaEmpresa);
    }
    this._unsubscribeAll = new Subject();
console.log("aqui no truena");
    this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
      // Update the stored config
      this.fuseConfig = config;
      // Set the config form values without emitting an event
      // so that we don't end up with an infinite loop
      this.form.setValue(config, {emitEvent: false});
    });
    this.form.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
      // Update the config
      console.log("cambiara tema");
      this._fuseConfigService.config = config;
    });
    this.traduceTextosTS();

  }


  downloadImage(){
     html2canvas(this.screen.nativeElement, { logging: true, letterRendering: 1} ).then(canvas => {
       this.canvas.nativeElement.src = canvas.toDataURL();
       this.downloadLink.nativeElement.href = canvas.toDataURL('image/png').replace("image/png", "image/octet-stream");
       this.downloadLink.nativeElement.download = 'CGO_Counts.png';
       this.downloadLink.nativeElement.click();
     });
   }





  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      // console.log(this.mensajesTraducirKeys[iter]);

      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
  this.idiomaActual = this.translateSrv.currentLang;
     console.log("si lo modifica ",this.idiomaActual);
  }

  calculoOffsetPipe(instit:any,diff?:any){
    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == instit);
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
  let horas = diff!=undefined?diff/60:this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    // this.city_name='TOOLBAR.CITIES.'+localStorage.getItem('instituto_id');
  }

  cambiaTema(instituto){
console.log('instituto********************',instituto);

    // if(instituto!=8){
    //   console.log("entrro",instituto);
    //
    //     this.form.controls['colorTheme'].setValue('temaFocusArea2');
    // }
  }

  customFilterPredicate() {
    const myFilterPredicate = (data: filtrosPortalConteosV2, filter: string): boolean => {

      let searchString = JSON.parse(filter);
      return data.Nivel_1.toString().trim().indexOf(searchString.Nivel_1) !== -1 &&
        data.Nivel_2.toString().trim().toLowerCase().indexOf(searchString.Nivel_2.toLowerCase()) !== -1 &&
        data.FILTRO.toString().trim().toLowerCase().indexOf(searchString.FILTRO.toLowerCase()) !== -1 &&
        data.SEGMENTO.toString().trim().toLowerCase().indexOf(searchString.SEGMENTO.toLowerCase()) !== -1;
    }
    return myFilterPredicate;
  }

  applyFilter(filterValue: any) {
     // this.filtroPortalv2.filter = filterValue.trim().toLowerCase();
     this.filtroPortalv2.filter = JSON.stringify(this.filteredValues);
   }

   seleccionarFiltro(nivel1: string){
     this.validacionNivel_1=true;
     let selectedNivel2:string[]=[];
     let selected:string[]=[];
     let selectedSegmentos:string[]=[];

     let nivel2:boolean=false;
     let filtro:boolean=false;
     let segmento:boolean=false;
     this.filteredValues['Nivel_1'] = nivel1;
     this.filtroPortalv2.filter = JSON.stringify(this.filteredValues);

    this.filtroPortalv2.filterPredicate = this.customFilterPredicate();
       // this.applyFilter(cargo);
       if(nivel1.length>0){
         if(this.validacionNivel_2==false){
           this.filtroPortalv2.filteredData.forEach(nivel2 => {
             if(nivel2.Nivel_1!="Fecha Consulta"){
               selectedNivel2.push(nivel2.Nivel_2);
             }
           });
           this.catalogoFiltroSeccionN_2 =Array.from(new Set(selectedNivel2)).sort();
           this.catalogoFiltrosN2=this.catalogoFiltroSeccionN_2;
         }
         else{
           if(this.filtroPortalv2.filteredData.length<1){
             this.seleccionarFiltro2('');
             nivel2=true;
           }
         }

         if(this.validacionDemografico==false){
           this.filtroPortalv2.filteredData.forEach(nombrefiltro => {
             if(nombrefiltro.Nivel_1!="Fecha Consulta"){
               selected.push(nombrefiltro.FILTRO);
             }
           });
           this.catalogoFiltroSeccionDemografico = Array.from(new Set(selected)).sort();
           this.catalogoFiltros=this.catalogoFiltroSeccionDemografico;
         }
         else{
           if(this.filtroPortalv2.filteredData.length<1){
             this.seleccionarFiltro3('');
             filtro=true;
           }
         }

         if(this.validacionSegmento==false){
           this.filtroPortalv2.filteredData.forEach(segmentofiltro => {
             if(segmentofiltro.Nivel_1!="Fecha Consulta"){
               selectedSegmentos.push(segmentofiltro.SEGMENTO);
             }
           });
           this.catalogoFiltroSeccionSegmento=Array.from(new Set(selectedSegmentos)).sort();
           this.catalogoFiltrosSegmento=this.catalogoFiltroSeccionSegmento;
         }
         else{
           if(this.filtroPortalv2.filteredData.length<1){
             this.seleccionarFiltro4('');
             segmento=true;
           }
         }
         if(nivel2==true){
           this.filtroPortalv2.filteredData.forEach(nivel2 => {
             if(nivel2.Nivel_1!="Fecha Consulta"){
               selectedNivel2.push(nivel2.Nivel_2);
             }
           });
           this.catalogoFiltroSeccionN_2 =Array.from(new Set(selectedNivel2)).sort();
           this.catalogoFiltrosN2=this.catalogoFiltroSeccionN_2;
         }

         if(filtro==true){
           this.filtroPortalv2.filteredData.forEach(nombrefiltro => {
             if(nombrefiltro.Nivel_1!="Fecha Consulta"){
               selected.push(nombrefiltro.FILTRO);
             }
           });
           this.catalogoFiltroSeccionDemografico = Array.from(new Set(selected)).sort();
           this.catalogoFiltros=this.catalogoFiltroSeccionDemografico;
         }

         if(segmento==true){
           this.filtroPortalv2.filteredData.forEach(segmentofiltro => {
             if(segmentofiltro.Nivel_1!="Fecha Consulta"){
               selectedSegmentos.push(segmentofiltro.SEGMENTO);
             }
           });
           this.catalogoFiltroSeccionSegmento=Array.from(new Set(selectedSegmentos)).sort();
           this.catalogoFiltrosSegmento=this.catalogoFiltroSeccionSegmento;
         }
       }
       else{
         if(this.validacionNivel_2==false){
           this.catalogoFiltrosN2=this.variableReservaN_2;
         }
         if(this.validacionDemografico==false){
           this.catalogoFiltros=this.variableReservaDemografico;
         }
         if(this.validacionSegmento==false){
           this.catalogoFiltrosSegmento=this.variableReservaSegmento;
         }
         this.validacionNivel_1=false;
       }
   }

   seleccionarFiltro2(nivel2: string){
     this.validacionNivel_2=true;
     let selectedNivel1:string[]=[];
     let selected:string[]=[];
     let selectedSegmentos:string[]=[];

     let nivel1:boolean=false;
     let filtro:boolean=false;
     let segmento:boolean=false;
     this.filteredValues['Nivel_2'] = nivel2;
     this.filtroPortalv2.filter = JSON.stringify(this.filteredValues);

     if(nivel2.length>0){
       if(this.validacionNivel_1==false){
         this.filtroPortalv2.filteredData.forEach(nivel1 => {
           if(nivel1.Nivel_1!="Fecha Consulta"){
             selectedNivel1.push(nivel1.Nivel_1);
           }
         });
         this.catalogoFiltroSeccionN_1 =Array.from(new Set(selectedNivel1)).sort();
         this.catalogoFiltrosN1=this.catalogoFiltroSeccionN_1;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro('');
           nivel1=true;
         }
       }

       if(this.validacionDemografico==false){
         this.filtroPortalv2.filteredData.forEach(nombrefiltro => {
           if(nombrefiltro.Nivel_1!="Fecha Consulta"){
             selected.push(nombrefiltro.FILTRO);
           }
         });
         this.catalogoFiltroSeccionDemografico = Array.from(new Set(selected)).sort();
         this.catalogoFiltros=this.catalogoFiltroSeccionDemografico;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro3('');
           filtro=true;
         }
       }

       if(this.validacionSegmento==false){
         this.filtroPortalv2.filteredData.forEach(segmentofiltro => {
           if(segmentofiltro.Nivel_1!="Fecha Consulta"){
             selectedSegmentos.push(segmentofiltro.SEGMENTO);
           }
         });
         this.catalogoFiltroSeccionSegmento=Array.from(new Set(selectedSegmentos)).sort();
         this.catalogoFiltrosSegmento=this.catalogoFiltroSeccionSegmento;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro4('');
           segmento=true;
         }
       }

       if(nivel1==true){
         this.filtroPortalv2.filteredData.forEach(nivel1 => {
           if(nivel1.Nivel_1!="Fecha Consulta"){
             selectedNivel1.push(nivel1.Nivel_1);
           }
         });
         this.catalogoFiltroSeccionN_1 =Array.from(new Set(selectedNivel1)).sort();
         this.catalogoFiltrosN1=this.catalogoFiltroSeccionN_1;
       }

       if(filtro==true){
         this.filtroPortalv2.filteredData.forEach(nombrefiltro => {
           if(nombrefiltro.Nivel_1!="Fecha Consulta"){
             selected.push(nombrefiltro.FILTRO);
           }
         });
         this.catalogoFiltroSeccionDemografico = Array.from(new Set(selected)).sort();
         this.catalogoFiltros=this.catalogoFiltroSeccionDemografico;
       }

       if(segmento==true){
         this.filtroPortalv2.filteredData.forEach(segmentofiltro => {
           if(segmentofiltro.Nivel_1!="Fecha Consulta"){
             selectedSegmentos.push(segmentofiltro.SEGMENTO);
           }
         });
         this.catalogoFiltroSeccionSegmento=Array.from(new Set(selectedSegmentos)).sort();
         this.catalogoFiltrosSegmento=this.catalogoFiltroSeccionSegmento;
       }

     }
     else{
       if(this.validacionNivel_1==false){
         this.catalogoFiltrosN1=this.variableReservaN_1;
       }
       if(this.validacionDemografico==false){
         this.catalogoFiltros=this.variableReservaDemografico;
       }
       if(this.validacionSegmento==false){
         this.catalogoFiltrosSegmento=this.variableReservaSegmento;
       }
       this.validacionNivel_2=false;
     }


    this.filtroPortalv2.filterPredicate = this.customFilterPredicate();
   }

   seleccionarFiltro3(filtro: string){
     this.validacionDemografico=true;
     let selectedNivel1:string[]=[];
     let selectedNivel2:string[]=[];
     let selectedSegmentos:string[]=[];

     let nivel1:boolean=false;
     let nivel2:boolean=false;
     let segmento:boolean=false;

     this.filteredValues['FILTRO'] = filtro;
     this.filtroPortalv2.filter = JSON.stringify(this.filteredValues);

     if(filtro.length>0){
       if(this.validacionNivel_1==false){
         this.filtroPortalv2.filteredData.forEach(nivel1 => {
           if(nivel1.Nivel_1!="Fecha Consulta"){
             selectedNivel1.push(nivel1.Nivel_1);
           }
         });
         this.catalogoFiltroSeccionN_1 =Array.from(new Set(selectedNivel1)).sort();
         this.catalogoFiltrosN1=this.catalogoFiltroSeccionN_1;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro('');
           nivel1=true;
         }
       }

       if(this.validacionNivel_2==false){
         this.filtroPortalv2.filteredData.forEach(nivel2 => {
           if(nivel2.Nivel_1!="Fecha Consulta"){
             selectedNivel2.push(nivel2.Nivel_2);
           }
         });
         this.catalogoFiltroSeccionN_2 =Array.from(new Set(selectedNivel2)).sort();
         this.catalogoFiltrosN2=this.catalogoFiltroSeccionN_2;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro2('');
           nivel2=true;
         }
       }

       if(this.validacionSegmento==false){
         this.filtroPortalv2.filteredData.forEach(segmentofiltro => {
           if(segmentofiltro.Nivel_1!="Fecha Consulta"){
             selectedSegmentos.push(segmentofiltro.SEGMENTO);
           }
         });
         this.catalogoFiltroSeccionSegmento=Array.from(new Set(selectedSegmentos)).sort();
         this.catalogoFiltrosSegmento=this.catalogoFiltroSeccionSegmento;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro4('');
           segmento=true;
         }
       }

       if(nivel1==true){
         this.filtroPortalv2.filteredData.forEach(nivel1 => {
           if(nivel1.Nivel_1!="Fecha Consulta"){
             selectedNivel1.push(nivel1.Nivel_1);
           }
         });
         this.catalogoFiltroSeccionN_1 =Array.from(new Set(selectedNivel1)).sort();
         this.catalogoFiltrosN1=this.catalogoFiltroSeccionN_1;
       }

       if(nivel2==true){
         this.filtroPortalv2.filteredData.forEach(nivel2 => {
           if(nivel2.Nivel_1!="Fecha Consulta"){
             selectedNivel2.push(nivel2.Nivel_2);
           }
         });
         this.catalogoFiltroSeccionN_2 =Array.from(new Set(selectedNivel2)).sort();
         this.catalogoFiltrosN2=this.catalogoFiltroSeccionN_2;
       }

       if(segmento==true){
         this.filtroPortalv2.filteredData.forEach(segmentofiltro => {
           if(segmentofiltro.Nivel_1!="Fecha Consulta"){
             selectedSegmentos.push(segmentofiltro.SEGMENTO);
           }
         });
         this.catalogoFiltroSeccionSegmento=Array.from(new Set(selectedSegmentos)).sort();
         this.catalogoFiltrosSegmento=this.catalogoFiltroSeccionSegmento;
       }

     }
     else{
       if(this.validacionNivel_1==false){
         this.catalogoFiltrosN1=this.variableReservaN_1;
       }
       if(this.validacionNivel_2==false){
         this.catalogoFiltrosN2=this.variableReservaN_2;
       }
       if(this.validacionSegmento==false){
         this.catalogoFiltrosSegmento=this.variableReservaSegmento;
       }
       this.validacionDemografico=false;
     }


    this.filtroPortalv2.filterPredicate = this.customFilterPredicate();
   }

   seleccionarFiltro4(segmento: string){
     this.validacionSegmento=true;
     let selectedNivel1:string[]=[];
     let selectedNivel2:string[]=[];
     let selected:string[]=[];

     let nivel1:boolean=false;
     let nivel2:boolean=false;
     let filtro:boolean=false;

     this.filteredValues['SEGMENTO'] = segmento;
     this.filtroPortalv2.filter = JSON.stringify(this.filteredValues);

     if(segmento.length>0){
       if(this.validacionNivel_1==false){
         this.filtroPortalv2.filteredData.forEach(nivel1 => {
           if(nivel1.Nivel_1!="Fecha Consulta"){
             selectedNivel1.push(nivel1.Nivel_1);
           }
         });
         this.catalogoFiltroSeccionN_1 =Array.from(new Set(selectedNivel1)).sort();
         this.catalogoFiltrosN1=this.catalogoFiltroSeccionN_1;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro('');
           nivel1=true;
         }
       }

       if(this.validacionNivel_2==false){
         this.filtroPortalv2.filteredData.forEach(nivel2 => {
           if(nivel2.Nivel_1!="Fecha Consulta"){
             selectedNivel2.push(nivel2.Nivel_2);
           }
         });
         this.catalogoFiltroSeccionN_2 =Array.from(new Set(selectedNivel2)).sort();
         this.catalogoFiltrosN2=this.catalogoFiltroSeccionN_2;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro2('');
           nivel2=true;
         }
       }

       if(this.validacionDemografico==false){
         this.filtroPortalv2.filteredData.forEach(nombrefiltro => {
           if(nombrefiltro.Nivel_1!="Fecha Consulta"){
             selected.push(nombrefiltro.FILTRO);
           }
         });
         this.catalogoFiltroSeccionDemografico = Array.from(new Set(selected)).sort();
         this.catalogoFiltros=this.catalogoFiltroSeccionDemografico;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro3('');
           filtro=true;
         }
       }

       if(nivel1==true){
         this.filtroPortalv2.filteredData.forEach(nivel1 => {
           if(nivel1.Nivel_1!="Fecha Consulta"){
             selectedNivel1.push(nivel1.Nivel_1);
           }
         });
         this.catalogoFiltroSeccionN_1 =Array.from(new Set(selectedNivel1)).sort();
         this.catalogoFiltrosN1=this.catalogoFiltroSeccionN_1;
       }

       if(nivel2==true){
         this.filtroPortalv2.filteredData.forEach(nivel2 => {
           if(nivel2.Nivel_1!="Fecha Consulta"){
             selectedNivel2.push(nivel2.Nivel_2);
           }
         });
         this.catalogoFiltroSeccionN_2 =Array.from(new Set(selectedNivel2)).sort();
         this.catalogoFiltrosN2=this.catalogoFiltroSeccionN_2;
       }

       if(filtro==true){
         this.filtroPortalv2.filteredData.forEach(nombrefiltro => {
           if(nombrefiltro.Nivel_1!="Fecha Consulta"){
             selected.push(nombrefiltro.FILTRO);
           }
         });
         this.catalogoFiltroSeccionDemografico = Array.from(new Set(selected)).sort();
         this.catalogoFiltros=this.catalogoFiltroSeccionDemografico;
       }

     }
     else{
       if(this.validacionNivel_1==false){
         this.catalogoFiltrosN1=this.variableReservaN_1;
       }
       if(this.validacionNivel_2==false){
         this.catalogoFiltrosN2=this.variableReservaN_2;
       }
       if(this.validacionDemografico==false){
         this.catalogoFiltros=this.variableReservaDemografico;
       }
       this.validacionSegmento=false;
     }


    this.filtroPortalv2.filterPredicate = this.customFilterPredicate();
   }

  getConteoFiltroNuevaVersion(productoId:any, empresaId:any){
    let label1='PORTAL.ETIQUETAS.ETIQUETAS';
    let label2='PORTAL.ETIQUETAS.OF';
    this.translateSrv.get(label1).subscribe((res: string) => { label1= res; });
    this.translateSrv.get(label2).subscribe((res: string) => { label2= res; });

    this.conteosService.getConteoExternoFiltroNuevaVersion(productoId,empresaId).subscribe( (data:backInter.portalConteosV2) => {
      console.log(data);
      data.result.forEach(nombrefiltro => {
        if(nombrefiltro.Nivel_1!="Fecha Consulta"){
          this.selected.push(nombrefiltro.FILTRO);
        }
      });

      data.result.forEach(segmentofiltro => {
        if(segmentofiltro.Nivel_1!="Fecha Consulta"){
          this.selectedSegmentos.push(segmentofiltro.SEGMENTO);
        }
      });

      data.result.forEach(nivel1 => {
        if(nivel1.Nivel_1!="Fecha Consulta"){
          this.selectedNivel1.push(nivel1.Nivel_1);
        }
      });

      data.result.forEach(nivel2 => {
        if(nivel2.Nivel_1!="Fecha Consulta"){
          this.selectedNivel2.push(nivel2.Nivel_2);
        }
      });

      // console.log(this.selected);
      this.catalogoFiltros = Array.from(new Set(this.selected));
      this.catalogoFiltrosSegmento=Array.from(new Set(this.selectedSegmentos)).sort();
      this.catalogoFiltrosN1 =Array.from(new Set(this.selectedNivel1)).sort();
      this.catalogoFiltrosN2 =Array.from(new Set(this.selectedNivel2)).sort();
      this.variableReservaN_1=this.catalogoFiltrosN1;
      this.variableReservaN_2=this.catalogoFiltrosN2;
      this.variableReservaDemografico=this.catalogoFiltros;
      this.variableReservaSegmento=this.catalogoFiltrosSegmento;
      data.result.splice(1, 1);
      this.filtrosExcelV2=data.result;
      this.filtroPortalv2 = new MatTableDataSource(data.result);
      this.filtroPortalv2.sort=this.sort;
      this.seleccionarFiltro('');
      setTimeout(() => this.filtroPortalv2.paginator=this.paginator);
      setTimeout(() => this.paginator._intl.itemsPerPageLabel=label1);
      setTimeout(() => this.paginator._intl.getRangeLabel=(page: number, pageSize: number, length: number) => { if (length == 0 || pageSize == 0)
        { return `0 ${label2} ${length}`; } length = Math.max(length, 0); const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} – ${endIndex} ${label2} ${length}`; });
      this.cargandoTablaFiltros= false;
    });
  }

  descargarExcelV2(){
    let nivel1: string;
    let nivel2: string;
    let demografico: string;
    let segmento: string;
    let total: string;
    let pendientes: string;
    let respondieron: string;
    let avancetexto: string;

    let tituloAvance: string;
    let sheet: string;
    let modal: string;
    let descarga: string;

    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.NIVEL1').subscribe((res: string) => { nivel1 = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.NIVEL2').subscribe((res: string) => { nivel2 = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.DEMOGRAFICO').subscribe((res: string) => { demografico = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.SEGMENTO').subscribe((res: string) => { segmento = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.COLABORADORES_T').subscribe((res: string) => { total = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.PENDIENTES_RESPONDER').subscribe((res: string) => { pendientes = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.YA_RESPONDIERON').subscribe((res: string) => { respondieron = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.AVANCE').subscribe((res: string) => { avancetexto = res; });

    this.translateSrv.get('PORTAL.EXCEL_V2.TITULO_AVANCE').subscribe((res: string) => { tituloAvance = res; });
    this.translateSrv.get('PORTAL.EXCEL_V2.SHEET').subscribe((res: string) => { sheet = res; });
    this.translateSrv.get('PORTAL.EXCEL_V2.DESCARGA').subscribe((res: string) => { modal = res; });
    this.translateSrv.get('PORTAL.EXCEL_V2.MODAL_DESCARGA').subscribe((res: string) => { descarga = res; });
    Swal.fire({
      title: this.mensajesTraducirTS.excel,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    let fecha = new Date();
    let fechaCompleta = fecha.getDate()+"/"+(fecha.getMonth()+1)+"/"+fecha.getFullYear();
    let hora = fecha.getHours()+":"+fecha.getMinutes()+":"+fecha.getSeconds();
    //Excel Title, Header, Data
    const title = this.nombreEmpresaFinal;
    const avance = tituloAvance+fechaCompleta+" "+hora;
    const header = [nivel1, nivel2, demografico, segmento, total, pendientes, respondieron, avancetexto]

    //Create workbook and worksheet
    const Excel = require('exceljs');
    const workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet(sheet);
    workbook.creator = 'CULTURAL GO PLATFORM';
    workbook.title = 'CULTURAL GO PLATFORM';

    //Add Row and formatting
    let titleRow = worksheet.addRow([title]);
    let avanceRow = worksheet.addRow([avance]);
    titleRow.font = { name: 'Calibri', family: 4, size: 14, underline: 'double', bold: true }
    avanceRow.font = { name: 'Calibri', family: 4, size: 14, bold: true }

    //Add Image
    // let logo = workbook.addImage({
    //   base64: logoFile.logoBase64,
    //   extension: 'png',
    // });
    // worksheet.addImage(logo, 'E1:F3');
    worksheet.mergeCells('A1:H1');
    worksheet.mergeCells('A2:H2');
    //Blank Row
    // worksheet.addRow([]);
    //Add Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.font = { name: 'Calibri', family: 4, bold: true }

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D8D8D8' }
        // bgColor: { argb: 'B8B5B5' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    this.filtrosExcelV2.forEach(element => {
      let porcentaje:any=((element.PROGRESO_TOTAL*100).toFixed(2));
      let porcentajeFinal:any;
      if(element.COLABORADORES_QUE_AUN_NO_RESPONDEN!='*' || element.COLABORADORES_QUE_YA_RESPONDIERON!='*'){
        porcentaje=((element.PROGRESO_TOTAL*100).toFixed(2));
        porcentajeFinal=parseFloat(porcentaje);
      }
      else{
      porcentajeFinal='*';
      }
      worksheet.addRow([element.Nivel_1,
        element.Nivel_2,
        element.FILTRO,
        element.SEGMENTO,
        element.TOTAL_DE_COLABORADORES,
        element.COLABORADORES_QUE_AUN_NO_RESPONDEN,
        element.COLABORADORES_QUE_YA_RESPONDIERON,
        porcentajeFinal
      ]);
    });
    // worksheet.addRows(data);
    // Add Data and Conditional Formatting
    // data.forEach(d => {
    //   let row = worksheet.addRow(d);
    //   let qty = row.getCell(5);
    //   let color = 'FF99FF99';
    //   if (+qty.value < 500) {
    //     color = 'FF9999'
    //   }
    //   qty.fill = {
    //     type: 'pattern',
    //     pattern: 'solid',
    //     fgColor: { argb: color }
    //   }
    // }
    // );
    worksheet.autoFilter = 'A3:H3';
    worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' };

    worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('B3').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('C3').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('D3').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('E3').alignment = { vertical: 'justify', horizontal: 'center' };
    worksheet.getCell('F3').alignment = { vertical: 'justify', horizontal: 'center' };
    worksheet.getCell('G3').alignment = { vertical: 'justify', horizontal: 'center' };
    worksheet.getCell('H3').alignment = { vertical: 'middle', horizontal: 'center' };


    worksheet.getColumn(1).width = 40;
    worksheet.getColumn(2).width = 40;
    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 40;
    worksheet.getColumn(5).width = 18;
    worksheet.getColumn(6).width = 18;
    worksheet.getColumn(7).width = 18;
    worksheet.getColumn(8).width = 30;
    worksheet.addRow([]);
    //Footer Row
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs.saveAs(blob,modal+this.nombreEmpresaFinal+'.xlsx');
      Swal.close();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: descarga,
        showConfirmButton: false,
        timer: 1500
      })
    })
  }

  customFilterPredicateReducido() {
    const myFilterPredicateReducido = (data: filtrosPortalConteosV2Reducido, filter: string): boolean => {

      let searchString = JSON.parse(filter);
      return data.FILTRO.toString().trim().toLowerCase().indexOf(searchString.FILTRO.toLowerCase()) !== -1 &&
      data.SEGMENTO.toString().trim().toLowerCase().indexOf(searchString.SEGMENTO.toLowerCase()) !== -1;
    }
    return myFilterPredicateReducido;

  }

  seleccionarFiltroReducido(filtro: any){
    this.validacionDemograficoReducido=true;
    let selectedSegmentos:string[]=[];

    this.filteredValuesReducido['FILTRO'] = filtro;
    this.filtroPortalv2Reducido.filter = JSON.stringify(this.filteredValuesReducido);
    this.filtroPortalv2Reducido.filterPredicate = this.customFilterPredicateReducido();

    if(filtro.length>0){
      if(this.validacionSegmentoReducido==false){
        this.filtroPortalv2Reducido.filteredData.forEach(segmentofiltro => {
          if(segmentofiltro.FILTRO!="Fecha Consulta"){
            selectedSegmentos.push(segmentofiltro.SEGMENTO);
          }
        });
        this.catalogoFiltroSeccionSegmentoReducido=Array.from(new Set(selectedSegmentos)).sort();
        this.catalogoFiltrosSegmentoReducido=this.catalogoFiltroSeccionSegmentoReducido;
      }
      else{
        if(this.filtroPortalv2Reducido.filteredData.length<1){
          this.seleccionarFiltroReducido2('');
          this.filtroPortalv2Reducido.filteredData.forEach(segmentofiltro => {
            if(segmentofiltro.FILTRO!="Fecha Consulta"){
              selectedSegmentos.push(segmentofiltro.SEGMENTO);
            }
          });
          this.catalogoFiltroSeccionSegmentoReducido=Array.from(new Set(selectedSegmentos)).sort();
          this.catalogoFiltrosSegmentoReducido=this.catalogoFiltroSeccionSegmentoReducido;
        }
      }

    }
    else{
      if(this.validacionSegmentoReducido==false){
        this.catalogoFiltrosSegmento=this.variableReservaSegmentoReducido;
      }
      this.validacionDemograficoReducido=false;
    }
  }

  seleccionarFiltroReducido2(segmento: string){
    this.validacionSegmentoReducido=true;
    let selected:string[]=[];

    this.filteredValuesReducido['SEGMENTO'] = segmento;
    this.filtroPortalv2Reducido.filter = JSON.stringify(this.filteredValuesReducido);

    if(segmento.length>0){
      if(this.validacionDemograficoReducido==false){
        this.filtroPortalv2Reducido.filteredData.forEach(nombrefiltro => {
          if(nombrefiltro.FILTRO!="Fecha Consulta"){
            selected.push(nombrefiltro.FILTRO);
          }
        });
        this.catalogoFiltroSeccionDemograficoReducido = Array.from(new Set(selected)).sort();
        this.catalogoFiltrosReducido=this.catalogoFiltroSeccionDemograficoReducido;
      }
      else{
        if(this.filtroPortalv2Reducido.filteredData.length<1){
          this.seleccionarFiltroReducido('');
          this.filtroPortalv2Reducido.filteredData.forEach(nombrefiltro => {
            if(nombrefiltro.FILTRO!="Fecha Consulta"){
              selected.push(nombrefiltro.FILTRO);
            }
          });
          this.catalogoFiltroSeccionDemograficoReducido = Array.from(new Set(selected)).sort();
          this.catalogoFiltrosReducido=this.catalogoFiltroSeccionDemograficoReducido;
        }
      }

    }
    else{
      if(this.validacionDemograficoReducido==false){
        this.catalogoFiltrosReducido=this.variableReservaDemograficoReducido;
      }
      this.validacionSegmentoReducido=false;
    }

   this.filtroPortalv2Reducido.filterPredicate = this.customFilterPredicateReducido();
  }

  getConteoFiltroNuevaVersionReducido(productoId:any, empresaId:any){
    this.conteosService.getConteoExternoFiltroNuevaVersionReducido(productoId,empresaId).subscribe( (data:backInter.portalConteosV2Reducido) => {
      console.log(data);
      data.result.forEach(nombrefiltro => {
        if(nombrefiltro.FILTRO!="Fecha Consulta"){
          this.selectedReducido.push(nombrefiltro.FILTRO);
        }
      });

      data.result.forEach(segmentofiltro => {
        if(segmentofiltro.FILTRO!="Fecha Consulta"){
          this.selectedSegmentosReducido.push(segmentofiltro.SEGMENTO);
        }
      });

      // console.log(this.selected);
      this.catalogoFiltrosReducido = Array.from(new Set(this.selectedReducido));
      this.catalogoFiltrosSegmentoReducido=Array.from(new Set(this.selectedSegmentosReducido)).sort();
      this.variableReservaDemograficoReducido=this.catalogoFiltrosReducido;
      this.variableReservaSegmentoReducido=this.catalogoFiltrosSegmentoReducido;
      data.result.splice(1, 1);
      this.filtrosExcelV2Reducido=data.result;
      this.filtroPortalv2Reducido = new MatTableDataSource(data.result);
      this.seleccionarFiltroReducido('');
      this.getConteoFiltroNuevaVersion(productoId, empresaId);
      this.seleccionarFiltroReducido('Company');
    });
  }

  descargarExcelReducido(){
    let demografico: string;
    let segmento: string;
    let total: string;
    let pendientes: string;
    let respondieron: string;
    let avancetexto: string;

    let tituloAvance: string;
    let sheet: string;
    let modal: string;
    let descarga: string;

    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.DEMOGRAFICO').subscribe((res: string) => { demografico = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.SEGMENTO').subscribe((res: string) => { segmento = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.COLABORADORES_T').subscribe((res: string) => { total = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.PENDIENTES_RESPONDER').subscribe((res: string) => { pendientes = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.YA_RESPONDIERON').subscribe((res: string) => { respondieron = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.AVANCE').subscribe((res: string) => { avancetexto = res; });

    this.translateSrv.get('PORTAL.EXCEL_V2.TITULO_AVANCE').subscribe((res: string) => { tituloAvance = res; });
    this.translateSrv.get('PORTAL.EXCEL_V2.SHEET').subscribe((res: string) => { sheet = res; });
    this.translateSrv.get('PORTAL.EXCEL_V2.DESCARGA').subscribe((res: string) => { modal = res; });
    this.translateSrv.get('PORTAL.EXCEL_V2.MODAL_DESCARGA').subscribe((res: string) => { descarga = res; });
    Swal.fire({
      title: this.mensajesTraducirTS.excel,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    let fecha = new Date();
    let fechaCompleta = fecha.getDate()+"/"+(fecha.getMonth()+1)+"/"+fecha.getFullYear();
    let hora = fecha.getHours()+":"+fecha.getMinutes()+":"+fecha.getSeconds();
    //Excel Title, Header, Data
    const title = this.nombreEmpresaFinal;
    const avance = tituloAvance+fechaCompleta+" "+hora;
    const header = [demografico, segmento, total, pendientes, respondieron, avancetexto]

    //Create workbook and worksheet
    const Excel = require('exceljs');
    const workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet(sheet);
    workbook.creator = 'CULTURAL GO PLATFORM';
    workbook.title = 'CULTURAL GO PLATFORM';

    //Add Row and formatting
    let titleRow = worksheet.addRow([title]);
    let avanceRow = worksheet.addRow([avance]);
    titleRow.font = { name: 'Calibri', family: 4, size: 14, underline: 'double', bold: true }
    avanceRow.font = { name: 'Calibri', family: 4, size: 14, bold: true }


    worksheet.mergeCells('A1:F1');
    worksheet.mergeCells('A2:F2');

    let headerRow = worksheet.addRow(header);
    headerRow.font = { name: 'Calibri', family: 4, bold: true }

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D8D8D8' }
        // bgColor: { argb: 'B8B5B5' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    this.filtrosExcelV2Reducido.forEach(element => {
      let porcentaje:any=((element.PROGRESO_TOTAL*100).toFixed(2));
      let porcentajeFinal:any;
      if(element.COLABORADORES_QUE_AUN_NO_RESPONDEN!='*' || element.COLABORADORES_QUE_YA_RESPONDIERON!='*'){
        porcentaje=((element.PROGRESO_TOTAL*100).toFixed(2));
        porcentajeFinal=parseFloat(porcentaje);
      }
      else{
      porcentajeFinal='*';
      }
      worksheet.addRow([
        element.FILTRO,
        element.SEGMENTO,
        element.TOTAL_DE_COLABORADORES,
        element.COLABORADORES_QUE_AUN_NO_RESPONDEN,
        element.COLABORADORES_QUE_YA_RESPONDIERON,
        porcentajeFinal
      ]);
    });

    worksheet.autoFilter = 'A3:F3';
    worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' };

    worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('B3').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('C3').alignment = { vertical: 'justify', horizontal: 'center' };
    worksheet.getCell('D3').alignment = { vertical: 'justify', horizontal: 'center' };
    worksheet.getCell('E3').alignment = { vertical: 'justify', horizontal: 'center' };
    worksheet.getCell('F3').alignment = { vertical: 'middle', horizontal: 'center' };


    worksheet.getColumn(1).width = 30;
    worksheet.getColumn(2).width = 40;
    worksheet.getColumn(3).width = 18;
    worksheet.getColumn(4).width = 18;
    worksheet.getColumn(5).width = 18;
    worksheet.getColumn(6).width = 30;
    worksheet.addRow([]);
    //Footer Row
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs.saveAs(blob,modal+this.nombreEmpresaFinal+'.xlsx');
      Swal.close();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: descarga,
        showConfirmButton: false,
        timer: 1500
      })
    })
  }

  onLinkClick(event: MatTabChangeEvent) {
    if(event.index==0){
    this.portalValidacion=false;
    }
    if(event.index==1){
      this.portalValidacion=true;
    }
  }

  getFiltros() {
    let dato={institutoId:this.selectInstituto};
    console.log(dato);

    this.conteosService.getListaFiltros(dato).subscribe((respuesta:backInter.getListaFiltros) => {
      console.log("Filtros");
      console.log(respuesta);
      this.listaFiltros = respuesta.filtros;
    }, error => {
      console.log(error);
    });
  }

   ///////funcion   para la empresa principal empresa
   getConteosClaves(){
     // this.cargando=true;
     this.unaEmpresa=true;
   this.cierreService.getConteosClave(this.claveConteos).subscribe((respuesta:backInter.getConteosClave) => {
    console.log(respuesta);
    this.conteosClaves = respuesta;
    this.cambiaTema(this.conteosClaves.instituto);
    this.calculoOffsetPipe(this.conteosClaves.instituto);
    this.tipoProducto = this.conteosClaves.clave.claveProducto.toString();
    this.encuestaID= this.conteosClaves.clave.encuestaId;
    this.nombreEmpresaFinal= this.conteosClaves.empresa;
    this.idProductoCertificares=respuesta.idProducto;
    this.respRecRes=this.conteosClaves.avance.respRecRes;
    this.respMinCer=this.conteosClaves.avance.respMinCer;
    console.log(this.encuestaID);
    if (respuesta.instituto==1 && !respuesta.resultsBoxEntregables && !respuesta.resultsBoxRanking) {
      this.resultsBoxEntregables=true;
      this.resultsBoxRanking=true;
    }else if( respuesta.instituto==2 && !respuesta.resultsBoxEntregables && !respuesta.resultsBoxRanking ){
      this.resultsBoxEntregables=false;
      this.resultsBoxRanking=true;
    }else{
      this.resultsBoxEntregables=respuesta.resultsBoxEntregables;
      this.resultsBoxRanking=respuesta.resultsBoxRanking;
    }
    switch (respuesta.instituto) {
      case 2:
      switch (this.tipoProducto) {
        case '100':
        this.textResultsBoxEntregables='PORTAL.REPORTE_MED_CARCA';
        this.textResultsBoxRanking='PORTAL.RANKING_MED_CARCA';

        this.textToolResultsBoxEntregables='PORTAL.TOOLT_REPORTE_MED_CARCA';
        this.textToolResultsBoxRanking='PORTAL.TOOLT_RANKING_MED_CARCA';

          break;

        default:
        this.textResultsBoxEntregables='PORTAL.REPORTE_CER_CARCA';
        this.textResultsBoxRanking='PORTAL.RANKING_CER_CARCA';

        this.textToolResultsBoxEntregables='PORTAL.TOOLT_REPORTE_CER_CARCA';
        this.textToolResultsBoxRanking='PORTAL.TOOLT_RANKING_CER_CARCA';
          break;
      }

        break;

      default:
      this.textResultsBoxEntregables='PORTAL.REPORTE';
      this.textResultsBoxRanking='PORTAL.RANKING';

      this.textToolResultsBoxEntregables='PORTAL.TOOLT_REPORTE';
      this.textToolResultsBoxRanking='PORTAL.TOOLT_RANKING';
        break;
    }
    console.log('this.tipoProducto',this.tipoProducto);
    let fechaLanzamiento1= moment();
    if(fechaLanzamiento1.isBefore(respuesta.lanzamiento)){
      this.fechaAnterior =true;
    }

    this.selectInstituto=respuesta.instituto;
    console.log(this.selectInstituto);
    console.log("TIPO DE PRODUCTOP");
    console.log(this.tipoProducto);
    this.getConteoFiltroNuevaVersionReducido(this.conteosClaves.clave.productoId, this.conteosClaves.clave.empresaId);

    //VALIDACION PARA EMPRESA "PORTAL INS && ENEL"
    if(this.conteosClaves.clave.empresaId=="5f77b3a2d97e914ebc58d0fa" || this.conteosClaves.clave.empresaId=="5f864cd10052cd27f091d1d0" || this.conteosClaves.clave.empresaId=="5e3da142bba6b50196786b6b"){
      this.visualizarCards=true;
    }

    switch(this.tipoProducto){
      case "1": this.urlProducto = 'certify';


      this.calcularVigencia(this.conteosClaves.cierre);
      this.totalUsers= this.conteosClaves.avance.totalUsers;
      this.sumaFormula1= this.totalUsers*((2.33*2.33)*.5*.5);
      this.sumaFormula2= ((.03*.03)*(this.totalUsers-1))+((2.33*2.33)*.5*.5);
      this.resultadoRanking= this.sumaFormula1/this.sumaFormula2;
      console.log(this.sumaFormula1);
      console.log(this.sumaFormula2);
      console.log(this.resultadoRanking);
      this.fxFlexEspacio=20;


        this.timeLineCertificar();
      this.getFiltros();
      break;
      case "7": this.urlProducto = 'certify';


      this.calcularVigencia(this.conteosClaves.cierre);
      this.totalUsers= this.conteosClaves.avance.totalUsers;
      this.sumaFormula1= this.totalUsers*((2.33*2.33)*.5*.5);
      this.sumaFormula2= ((.03*.03)*(this.totalUsers-1))+((2.33*2.33)*.5*.5);
      this.resultadoRanking= this.sumaFormula1/this.sumaFormula2;
      console.log(this.sumaFormula1);
      console.log(this.sumaFormula2);
      console.log(this.resultadoRanking);
      this.fxFlexEspacio=20;


        this.timeLineCertificar();
      this.getFiltros();
      break;
      case "c1": this.urlProducto = 'certify';
      console.log("ES UN CERTIFICAR");

      this.calcularVigencia(this.conteosClaves.cierre);
      this.totalUsers= this.conteosClaves.avance.totalUsers;
      this.sumaFormula1= this.totalUsers*((2.33*2.33)*.5*.5);
      this.sumaFormula2= ((.03*.03)*(this.totalUsers-1))+((2.33*2.33)*.5*.5);
      this.resultadoRanking= this.sumaFormula1/this.sumaFormula2;
      console.log(this.sumaFormula1);
      console.log(this.sumaFormula2);
      console.log(this.resultadoRanking);
      this.fxFlexEspacio=20;
      this.timeLineCertificar();
      this.getFiltros();
      break;
      case "c2":
      this.urlProducto = 'certify_t2';
      console.log("ES UN CERTIFICAR 2.0");

      this.calcularVigencia(this.conteosClaves.cierre);
      this.totalUsers= this.conteosClaves.avance.totalUsers;
      this.sumaFormula1= this.totalUsers*((2.33*2.33)*.5*.5);
      this.sumaFormula2= ((.03*.03)*(this.totalUsers-1))+((2.33*2.33)*.5*.5);
      this.resultadoRanking= this.sumaFormula1/this.sumaFormula2;
      console.log(this.sumaFormula1);
      console.log(this.sumaFormula2);
      console.log(this.resultadoRanking);
      this.fxFlexEspacio=20;
      this.timeLineCertificar();
      this.getFiltros();
      break;
      case "c3": this.urlProducto = 'certify_3';
      console.log("ES UN CERTIFICAR");

      this.calcularVigencia(this.conteosClaves.cierre);
      this.totalUsers= this.conteosClaves.avance.totalUsers;
      this.sumaFormula1= this.totalUsers*((2.33*2.33)*.5*.5);
      this.sumaFormula2= ((.03*.03)*(this.totalUsers-1))+((2.33*2.33)*.5*.5);
      this.resultadoRanking= this.sumaFormula1/this.sumaFormula2;
      console.log(this.sumaFormula1);
      console.log(this.sumaFormula2);
      console.log(this.resultadoRanking);
      this.fxFlexEspacio=20;
      this.timeLineCertificar();
      this.getFiltros();
      break;
      case "2": this.urlProducto = 'measurement';
      this.calcularVigencia(this.conteosClaves.cierre);
      this.timeLineMedir();
      this.getFiltros();
      break;

      case "4": this.urlProducto = 'pulse';
      this.calcularVigencia(this.conteosClaves.cierre);
      this.timeLinePulse();
      this.getFiltros();
      break;
      case "6": this.urlProducto = 'focus';
      console.log(this.urlProducto);
      console.log("Focus Area");

      this.calcularVigencia(this.conteosClaves.cierre);
      this.getFiltros();
      this.timeLineFocusArea();
      break;
      case "5": this.urlProducto = 'norm';
      this.calcularVigencia(this.conteosClaves.cierre);
      this.getFiltros();
      break;
      default: break;
      case "m1": this.urlProducto = 'measurement_t1';
      this.calcularVigencia(this.conteosClaves.cierre);
      this.timeLineMedir();
      this.getFiltros();
      break;
      case "m2": this.urlProducto = 'measurement_t2';
      this.calcularVigencia(this.conteosClaves.cierre);
      this.timeLineMedir();
      this.getFiltros();
      break;
      case "m3": this.urlProducto = 'measurement_t3';
      this.calcularVigencia(this.conteosClaves.cierre);
      this.timeLineMedir();
      this.getFiltros();
      break;
      case "m4": this.urlProducto = 'measurement_t4';
      this.calcularVigencia(this.conteosClaves.cierre);
      this.timeLineMedir();
      this.getFiltros();
      break;
      case "m5": this.urlProducto = 'measurement_t5';
      this.calcularVigencia(this.conteosClaves.cierre);
      this.timeLineMedir();
      this.getFiltros();
      break;
      case "m6": this.urlProducto = 'measurement_6';
      this.calcularVigencia(this.conteosClaves.cierre);
      this.timeLineMedir();
      this.getFiltros();
      break;

    }

  }, error => {
    console.log(error);
  });
  }
  ///////funcion  solamente para la segunda empresa

   getConteosClavesEmpresa2(){

     this.unaEmpresa=true;
   this.cierreService.getConteosClave(this.claveAccesoEmpresa2).subscribe((respuesta:backInter.getConteosClave) => {
    console.log(respuesta);

    this.conteosClaves2Empresa = respuesta;
    this.tipoProducto = this.conteosClaves2Empresa.clave.claveProducto.toString();
    this.encuestaID= this.conteosClaves2Empresa.clave.encuestaId;
    console.log(this.encuestaID);

    this.selectInstituto=respuesta.instituto;
    console.log(this.selectInstituto);
    console.log("TIPO DE PRODUCTOP");
    console.log(this.tipoProducto);

    switch(this.tipoProducto){
      case "1": this.urlProducto = 'certify';

      this.calcularVigencia(this.conteosClaves.cierre);
      this.totalUsers= this.conteosClaves2Empresa.avance.totalUsers;
      console.log(this.totalUsers);

      this.sumaFormula1= this.totalUsers*((2.33*2.33)*.5*.5);
      this.sumaFormula2= ((.03*.03)*(this.totalUsers-1))+((2.33*2.33)*.5*.5);
      this.resultadoRanking= this.sumaFormula1/this.sumaFormula2;
      console.log(this.sumaFormula1);
      console.log(this.sumaFormula2);
      console.log(this.resultadoRanking);
      this.fxFlexEspacio=20;
      this.timeLineCertificarEmpresa2();
      this.getFiltros();
      break;
    }

  }, error => {
    console.log(error);
  });
  }
//////funcion para las dos empresas

   getConteosClavesVersion2(){
     this.unaEmpresa=false;
     console.log(this.claveConteos);
  this.cierreService.getConteosClave(this.claveConteos).subscribe((respuesta:backInter.getConteosClave) => {
      console.log(respuesta);
      this.conteosClaves = respuesta;
      console.log(this.claveAccesoEmpresa2);
        this.cierreService.getConteosClave(this.claveAccesoEmpresa2).subscribe((respuesta2:backInter.getConteosClave) => {
   console.log(respuesta2);
   this.conteosClaves2Empresa=respuesta2;
   this.tipoProducto = this.conteosClaves2Empresa.clave.claveProducto.toString();
   this.encuestaID= this.conteosClaves2Empresa.clave.encuestaId;

   this.selectInstituto=respuesta.instituto;
   // console.log(this.totalColaboradores2Empresas);
   // console.log(this.totalColaboradoresFaltantes2Empresas);
   // console.log(this.totalPorcentaje2Empresas);

   switch(this.tipoProducto){
     case "1": this.urlProducto = 'certify';

     // this.calcularVigencia(this.conteosClaves.clave.createdAt);
     this.totalUsers= this.conteosClaves.avance.totalUsers;
     this.sumaFormula1= this.totalUsers*((2.33*2.33)*.5*.5);
     this.sumaFormula2= ((.03*.03)*(this.totalUsers-1))+((2.33*2.33)*.5*.5);
     this.resultadoRanking= this.sumaFormula1/this.sumaFormula2;
     console.log(this.sumaFormula1);
     console.log(this.sumaFormula2);
     console.log(this.resultadoRanking);
     if (!this.empresasBaxter) {
       this.totalColaboradores2Empresas=this.conteosClaves.avance.totalUsers+this.conteosClaves2Empresa.avance.totalUsers;
     }else{
       this.totalColaboradores2Empresas=this.conteosClaves.avance.totalUsers;
     }
     this.totalColaboradoresFinalizaron2Empresas=this.conteosClaves.avance.endUsers+this.conteosClaves2Empresa.avance.endUsers;
     this.totalPorcentaje2Empresas=(100/this.totalColaboradores2Empresas)*(this.totalColaboradoresFinalizaron2Empresas);

     this.fxFlexEspacio=20;
     this.timeLineCertificar2Empresa();
     this.getFiltros();
     break;

   }
});
 }, error => {
   console.log(error);
 });
 }

///////funcion   para la empresa principal empresa
  getConteosF(dato: number, nombre:string) {
    this.idFiltro=dato;
    this.translateSrv.get('PORTAL.FILTROS.'+dato).subscribe((res1: string) => { this.nombre = res1; });
    let idproducto= this.conteosClaves.clave.productoId;
    console.log();

    let idfiltro= dato;
    let datos:any = {productoId:idproducto, filtroId:idfiltro };
    //PULSECHECK
    let idEncuesta=localStorage.getItem('encuestaID');
    let data:any = {productoId:idproducto,filtroId:idfiltro, encuestaId:idEncuesta};
    let dataFocus:any = {filtroId:idfiltro};

    console.log(data);

    this.cargandoFiltros=true;
    this.mensaje=false;
    switch(this.tipoProducto){
      case "1":
      console.log(datos);

      this.conteosService.getConteoFiltroPortalCer(datos,this.conteosClaves.clave.empresaId).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;
      }
      else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }
      }, error => {
        console.log(error);
      });
      break;
      case "c1": case "c2": case "c3": case "7":
      console.log(datos);
      this.conteosService.getConteoFiltroPortalCer(datos,this.conteosClaves.clave.empresaId).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;
      }
      else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }
       this.cambiaColorProgress();

      }, error => {
        console.log(error);
      });
      break;
      case "2":
      console.log(datos);
      this.conteosService.getConteoFiltroPortalMedir(datos,this.conteosClaves.clave.empresaId).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;
      }
      else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }
      this.cambiaColorProgress();
      }, error => {
        console.log(error);
      });
      break;
      case "4":
      console.log(data);
      this.conteosService.getConteoFiltroPortalPulse(data,this.conteosClaves.clave.empresaId).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;
      }
      else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }
        this.cambiaColorProgress();
      }, error => {
        console.log(error);
      });
     break;
      case "6":
      console.log(dataFocus);
      this.conteosService.getConteoFiltroPortalFocusArea(dataFocus,this.encuestaID).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;
      }
      else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }
        this.cambiaColorProgress();
      }, error => {
        console.log(error);
      });
     break;
    }
  }
  ///////funcion  solamente para la segunda empresa
getConteosFEmpresa2(dato: number, nombre:string) {
    this.idFiltro=dato;
    this.translateSrv.get('PORTAL.FILTROS.'+dato).subscribe((res1: string) => { this.nombre = res1; });
    let idproducto2empresa=this.conteosClaves2Empresa.clave.productoId;
    console.log();

    let idfiltro= dato;
    let datosempresa2:any = {productoId:idproducto2empresa, filtroId:idfiltro };
    //PULSECHECK

    this.cargandoFiltros=true;
    this.mensaje=false;
    switch(this.tipoProducto){
      case "1":
      this.conteosService.getConteoFiltroPortalCer(datosempresa2,this.conteosClaves2Empresa.clave.empresaId).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;
      }
      else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }
      }, error => {
        console.log(error);
      });
      break;

    }
  }
//////funcion para las dos empresas
  getConteosF2Empresas(dato: number, nombre:string) {
    this.idFiltro=dato;
    this.translateSrv.get('PORTAL.FILTROS.'+dato).subscribe((res1: string) => { this.nombre = res1; });
    let idproducto= this.conteosClaves.clave.productoId;
    let idproducto2empresa=this.conteosClaves2Empresa.clave.productoId;


    let idfiltro= dato;
    let datos:any = {productoId:idproducto, filtroId:idfiltro };
    let datosempresa2:any = {productoId:idproducto2empresa, filtroId:idfiltro };
    let dataFocus:any = {filtroId:idfiltro};
    let  endUsers1:number;
    let  endUsers2:number;
    let  totalUsers1:number;
    let  totalUsers2:number;
    let filtros2Empresa: any[] = [];
    this.filtrados2empresas= [];
    let resultado={}


    this.cargandoFiltros=true;
    this.mensaje=false;
    switch(this.tipoProducto){
      case "1":
      console.log(datos);

      this.conteosService.getConteoFiltroPortalCer(datos,this.conteosClaves.clave.empresaId).subscribe((respuesta: backInter.getConteosFiltros) => {
          this.resultadoConteo = respuesta;
          console.log(respuesta);
          this.conteosService.getConteoFiltroPortalCer(datosempresa2,this.conteosClaves2Empresa.clave.empresaId).subscribe((respuesta2: backInter.getConteosFiltros) => {
            this.resultadoConteo2Empresa = respuesta2;
        console.log(respuesta2);
        if (this.resultadoConteo.resultado.length==0) {
          this.mensaje=true;
        }

     this.resultadoConteo.resultado.forEach(resulEmpresa1 => {
        let indice1 = this.resultadoConteo2Empresa.resultado.findIndex(item => item.filtro === resulEmpresa1.filtro);
         if(indice1 == -1){
           let indice2 = filtros2Empresa.findIndex(item => item.filtro === resulEmpresa1.filtro);
           if(indice2 == -1){
             // console.log(" agrego el filtro ",resulEmpresa1.filtro);

             filtros2Empresa.push({endUsers: resulEmpresa1.endUsers,filtro: resulEmpresa1.filtro,porcentaje: (100/resulEmpresa1.totalUsers)*(resulEmpresa1.endUsers),totalUsers:resulEmpresa1.totalUsers});
          }


        }else{

          this.resultadoConteo2Empresa.resultado.forEach(resulEmpresa2 => {
         if(resulEmpresa1.filtro==resulEmpresa2.filtro){
           let indice = filtros2Empresa.findIndex(item => item.filtro === resulEmpresa1.filtro);
           if(indice == -1){
             console.log(" agrego el filtro ",resulEmpresa1.filtro);
             if(!this.empresasBaxter){
               console.log("no es Baxter");

               filtros2Empresa.push({endUsers: resulEmpresa1.endUsers+resulEmpresa2.endUsers,filtro: resulEmpresa1.filtro,porcentaje: ((100/(resulEmpresa1.totalUsers+resulEmpresa2.totalUsers))*(resulEmpresa1.endUsers+resulEmpresa2.endUsers)),totalUsers:resulEmpresa1.totalUsers+resulEmpresa2.totalUsers});
             }else{
               console.log("SI es Baxter YEAHH");
               filtros2Empresa.push({endUsers: resulEmpresa1.endUsers+resulEmpresa2.endUsers,filtro: resulEmpresa1.filtro,porcentaje: ((100/(resulEmpresa1.totalUsers))*(resulEmpresa1.endUsers+resulEmpresa2.endUsers)),totalUsers:resulEmpresa1.totalUsers});

             }
          }else{
            if(!this.empresasBaxter){
            filtros2Empresa[indice].endUsers= resulEmpresa1.endUsers+resulEmpresa2.endUsers;
            filtros2Empresa[indice].porcentaje= ((100/(resulEmpresa1.totalUsers+resulEmpresa2.totalUsers))*(resulEmpresa1.endUsers+resulEmpresa2.endUsers));
            filtros2Empresa[indice].totalUsers= resulEmpresa1.totalUsers+resulEmpresa2.totalUsers;
            }else{
              console.log("SI es Baxter YEAHH");
              filtros2Empresa[indice].endUsers= resulEmpresa1.endUsers+resulEmpresa2.endUsers;
              filtros2Empresa[indice].porcentaje= ((100/(resulEmpresa1.totalUsers))*(resulEmpresa1.endUsers+resulEmpresa2.endUsers));
              filtros2Empresa[indice].totalUsers= resulEmpresa1.totalUsers;
            }

          }


        }else{
          let indice = filtros2Empresa.findIndex(item => item.filtro === resulEmpresa2.filtro);
          if(indice == -1){
          filtros2Empresa.push({endUsers: resulEmpresa2.endUsers,filtro: resulEmpresa2.filtro,porcentaje: (100/resulEmpresa2.totalUsers)*(resulEmpresa2.endUsers),totalUsers:resulEmpresa2.totalUsers});
                  }

        }

       });
     }




     });
     this.filtrados2empresas=filtros2Empresa;
     console.log(this.filtrados2empresas);
     this.cargandoFiltros=false;
      // if(respuesta2.resultado.length >0){
      //   this.cargandoFiltros=false;
      // }
      // else{
      //   console.log("no tiene nada ");
      // this.cargandoFiltros=false;
      // this.mensaje=true;
      // }

    });
      }, error => {
        console.log(error);
      });
      break;
    }
  }

  cambiaColorProgress() {
    const head = document.getElementsByTagName('head')[0];
    let css='';
    css = css+`
    .prro .mat-progress-bar-fill::after {
      background-color: #28a745 !important;
    }
    .izzi .mat-progress-bar-fill::after {
      background-color: #25b7b3 !important;
    }
    .gcti .mat-progress-bar-fill::after {
      background-color: #960EBD !important;
    }
    body.temaFocusArea2 .mat-progress-bar-background{
      fill: #97C284 !important;
    }`;

    // if(this.progreso >0 && this.progreso<50){
    //   css = css+`
    //   .barcolor .mat-progress-bar-fill::after {
    //     background-color: #28a745 !important;
    //   }
    //   body.temaFocusArea2 .mat-progress-bar-background{
    //     fill: #D6D7D8 !important;
    //   }`;
    // };
    // if(this.progreso >=50 && this.progreso <=70){
    //   css = css+`
    //   .barcolor .mat-progress-bar-fill::after {
    //     background-color:#ffc107 !important;
    //   }
    //   body.temaFocusArea2 .mat-progress-bar-background{
    //     fill: #D6D7D8 !important;
    //   }`;
    // };
    // if(this.progreso >=71 && this.progreso ==100){
    //   css = css+`
    //   .barcolor .mat-progress-bar-fill::after {
    //     background-color: #FC150E !important;
    //   }
    //   body.temaFocusArea2 .mat-progress-bar-background{
    //     fill: #D6D7D8 !important;
    //   }`;
    // };

    this.styleElement.innerHTML = '';
    this.styleElement.type = 'text/css';
    this.styleElement.appendChild(document.createTextNode(css));
    head.appendChild(this.styleElement);

  }



    calcularVigencia(fecha:string){
      var moment = require('moment');
      // let fechaNuevaCierre=new Date();
      let title = 'PORTAL.ACCESODENEGADO';
      // let fechaAnterior=new Date(fecha);
      let fechaActualNave= moment();
      this.fechaClave=fecha;
      let fechaCierreMas9Dias= moment(fecha).add(9, 'days');
      // fechaNuevaCierre.setDate(fechaAnterior.getDate()+9);
      // console.log("fecha Anterior ",fechaAnterior);
      // console.log("fecha Nueva de cierre  mas 9 Dias ",fechaNuevaCierre);
      console.log("fecha Nueva de cierre  mas 9 Dias 2+2+2",fechaCierreMas9Dias);

      this.translateSrv.get(title).subscribe((res: string) => { title= res; });
      let portarActivo= moment(fechaActualNave) < moment(fechaCierreMas9Dias)
      let fechaPostClose= moment(fechaActualNave).isAfter(moment(fecha));
      let obtenerDiasRest= fechaCierreMas9Dias.diff(fechaActualNave,'days');
      // console.log('portarActivo',portarActivo);
      // console.log('fechaActualNave',fechaActualNave);
      // console.log('fechaCierreMas9Dias cierre ',moment(fechaCierreMas9Dias).format("DD/MM/YYYY"));
      // console.log('fecha fechaActualNave ',moment(fechaActualNave).format("DD/MM/YYYY"));
      // console.log("se han agregado  los dias de diferencia ",obtenerDiasRest);
      //
      if (fechaPostClose && portarActivo) {
        let numDiasResta= 9-obtenerDiasRest;
        console.log('numDiasResta',numDiasResta);

        Swal.fire({
        icon: 'info',
        title: this.translateSrv.instant('PORTAL.ACCESOMSJPRE_1')+numDiasResta+this.translateSrv.instant('PORTAL.ACCESOMSJPRE_2'),
        showConfirmButton: true,
        confirmButtonText: this.translateSrv.instant('PORTAL.BTNOK'),
        // allowOutsideClick: false
      })
      }

      if(!portarActivo){
        // this.linkValido=false;
      //   Swal.fire({
      //   icon: 'error',
      //   title: title,
      //   showConfirmButton: false,
      //   allowOutsideClick: false
      // })
      }

    }

    timeLineCertificar(){
      // let datos:any= {productoId: localStorage.getItem('productoID')};
      // console.log(datos);
     this.conteosService.getTimeLineGraficaCertificarForaneo(this.conteosClaves.clave.empresaId, this.conteosClaves.clave.productoId).subscribe((data: backInter.timeLineGraficaCertificar) => {
    console.log(data);

       let datas:any[]=[];
       let i=0;
       let labelsFechas:any[]=[];
       let valorMayor: any[]=[];
       let labelsFechasLine:any[]=[];
       let valorMayorLine: any[]=[];
     data.resultado.forEach(element => {
       let objeto={x:0, y:-1,r:0};
       objeto.x=i;
       objeto.y=element.endUsers;
       objeto.r=6;
       datas.push(objeto);
       labelsFechas.push(element.fecha);
       valorMayor.push(element.endUsers);
    i++;
     });

     data.resultado.forEach(element => {
       // labelsFechasLine.push(element.fecha);
        // console.log('',this.datePipe.transform(new Date(element.fecha),'d MMM y',this.offsetPipe,this.idiomaActual));
       labelsFechasLine.push(this.datePipe.transform(new Date(element.fecha),'d MMM y','+0000',this.idiomaActual));
       valorMayorLine.push(element.endUsers);

       i++;
     });
     this.lineChartData[0].data=valorMayorLine;
     this.lineChartLabels=labelsFechasLine;
     console.log(this.lineChartData);
     this.graficaValoresLine(labelsFechasLine);

       this.graficaValores(labelsFechas,valorMayor,labelsFechas.length);
       this.bubbleChartData[0].data = datas;
       console.log(this.bubbleChartData);
       this.datosEncontrados=true;
       this.timeLineGraficaCer = data;
       // console.log(this.timeLineGraficaCer);

        // this.cargandoFiltros=false;
      }, error => {
        console.log(error);
      });



    }

    timeLineCertificarEmpresa2(){
      // let datos:any= {productoId: localStorage.getItem('productoID')};
      // console.log(datos);
     this.conteosService.getTimeLineGraficaCertificarForaneo(this.conteosClaves2Empresa.clave.empresaId, this.conteosClaves2Empresa.clave.productoId).subscribe((data: backInter.timeLineGraficaCertificar) => {
    console.log(data);

       let datas:any[]=[];
       let i=0;
       let labelsFechas:any[]=[];
       let valorMayor: any[]=[];
       let labelsFechasLine:any[]=[];
       let valorMayorLine: any[]=[];
     data.resultado.forEach(element => {
       let objeto={x:0, y:-1,r:0};
       objeto.x=i;
       objeto.y=element.endUsers;
       objeto.r=6;
       datas.push(objeto);
       labelsFechas.push(element.fecha);
       valorMayor.push(element.endUsers);
    i++;
     });



          data.resultado.forEach(element => {
            labelsFechasLine.push(this.datePipe.transform(new Date(element.fecha),'d MMM y','+0000',this.idiomaActual));
            valorMayorLine.push(element.endUsers);

            i++;
          });
          this.lineChartData[0].data=valorMayorLine;
          this.lineChartLabels=labelsFechasLine;
          console.log(this.lineChartData);
          this.graficaValoresLine(labelsFechasLine);

       this.graficaValores(labelsFechas,valorMayor,labelsFechas.length);
       this.bubbleChartData[0].data = datas;
       console.log(this.bubbleChartData);
       this.datosEncontrados=true;
       this.timeLineGraficaCer = data;
       // console.log(this.timeLineGraficaCer);

        // this.cargandoFiltros=false;
      }, error => {
        console.log(error);
      });



    }

    timeLineCertificar2Empresa(){
      let resultadostimeline2Empresa:any[]=[];
     this.conteosService.getTimeLineGraficaCertificarForaneo(this.conteosClaves.clave.empresaId, this.conteosClaves.clave.productoId).subscribe((timeline1: backInter.timeLineGraficaCertificar) => {
       console.log(timeline1);
       this.conteosService.getTimeLineGraficaCertificarForaneo(this.conteosClaves2Empresa.clave.empresaId, this.conteosClaves2Empresa.clave.productoId).subscribe((timeline2: backInter.timeLineGraficaCertificar) => {
         console.log(timeline2);

           timeline1.resultado.forEach(resultadotimeline1 => {
             let indice1 = timeline2.resultado.findIndex(item => item.fecha === resultadotimeline1.fecha);
             if(indice1 == -1){
               let indice2 = resultadostimeline2Empresa.findIndex(item => item.fecha === resultadotimeline1.fecha);
               if(indice2 == -1){
                 // console.log(' entro este visne ',resultadotimeline1.fecha);
            resultadostimeline2Empresa.push({fecha: resultadotimeline1.fecha,endUsers:resultadotimeline1.endUsers});
          }
        }else{
           timeline2.resultado.forEach(resultadotimeline2 => {
               if (resultadotimeline1.fecha==resultadotimeline2.fecha) {
                 let indice4 = resultadostimeline2Empresa.findIndex(item => item.fecha === resultadotimeline1.fecha);
                 if(indice4 == -1){
                   console.log(' entro este visne ',resultadotimeline1.fecha);

                resultadostimeline2Empresa.push({fecha: resultadotimeline1.fecha,endUsers:resultadotimeline1.endUsers+resultadotimeline2.endUsers});
              }else{
                resultadostimeline2Empresa[indice4].endUsers= resultadotimeline1.endUsers+resultadotimeline2.endUsers;
              }
            }
            else{
              let indice3 = resultadostimeline2Empresa.findIndex(item => item.fecha === resultadotimeline2.fecha);
              if(indice3 == -1){
                // console.log(' entro este visne ',resultadotimeline2.fecha);
                resultadostimeline2Empresa.push({fecha: resultadotimeline2.fecha,endUsers:resultadotimeline2.endUsers});

              }
            }

             });

           }


           });
           this.timeLine2empresas.push(resultadostimeline2Empresa);
           console.log(this.timeLine2empresas);


//////////////////////////ProcesoActual para time line

       let datas:any[]=[];
       let i=0;
       let labelsFechas:any[]=[];
       let valorMayor: any[]=[];
       let labelsFechasLine:any[]=[];
       let valorMayorLine: any[]=[];
     this.timeLine2empresas[0].forEach(element => {
       let objeto={x:0, y:-1,r:0};
       objeto.x=i;
       objeto.y=element.endUsers;
       objeto.r=6;
       datas.push(objeto);
       labelsFechas.push(element.fecha);
       valorMayor.push(element.endUsers);
    i++;
     });

          this.timeLine2empresas[0].forEach(element => {
            labelsFechasLine.push(this.datePipe.transform(new Date(element.fecha),'d MMM y','+0000',this.idiomaActual));
            valorMayorLine.push(element.endUsers);

            i++;
          });
          this.lineChartData[0].data=valorMayorLine;
          this.lineChartLabels=labelsFechasLine;
          console.log(this.lineChartData);
          this.graficaValoresLine(labelsFechasLine);




       this.graficaValores(labelsFechas,valorMayor,labelsFechas.length);
       this.bubbleChartData[0].data = datas;
       console.log(this.bubbleChartData);
       this.datosEncontrados=true;
       this.timeLineGraficaCer = timeline1;
       // console.log(this.timeLineGraficaCer);

        // this.cargandoFiltros=false;
      });


      }, error => {
        console.log(error);
      });



    }

    timeLineFocusArea(){
      // let datos:any= {productoId: localStorage.getItem('productoID')};
      // console.log(datos);
     this.conteosService.getTimeLineGraficaFocusAreaForaneo(this.conteosClaves.clave.empresaId, this.conteosClaves.clave.encuestaId).subscribe((data: backInter.timeLineGraficaCertificar) => {
    // console.log(data);

       let datas:any[]=[];
       let i=0;
       let labelsFechas:any[]=[];
       let valorMayor: any[]=[];
       let labelsFechasLine:any[]=[];
       let valorMayorLine: any[]=[];
     data.resultado.forEach(element => {
       let objeto={x:0, y:-1,r:0};
       objeto.x=i;
       objeto.y=element.endUsers;
       objeto.r=6;
       datas.push(objeto);
       labelsFechas.push(element.fecha);
       valorMayor.push(element.endUsers);
    i++;
     });
     data.resultado.forEach(element => {
       labelsFechasLine.push(this.datePipe.transform(new Date(element.fecha),'d MMM y','+0000',this.idiomaActual));
       valorMayorLine.push(element.endUsers);

       i++;
     });
     this.lineChartData[0].data=valorMayorLine;
     this.lineChartLabels=labelsFechasLine;
     console.log(this.lineChartData);
     this.graficaValoresLine(labelsFechasLine);
       this.graficaValores(labelsFechas,valorMayor,labelsFechas.length);
       this.bubbleChartData[0].data = datas;
       console.log(this.bubbleChartData);
       this.datosEncontrados=true;
       this.timeLineGraficaCer = data;
       // console.log(this.timeLineGraficaCer);

        // this.cargandoFiltros=false;
      }, error => {
        console.log(error);
      });



    }

    timeLineMedir(){
      // let datos:any= {productoId: localStorage.getItem('productoID')};
      // console.log(datos);
     this.conteosService.getTimeLineGraficaMedirForaneo(this.conteosClaves.clave.empresaId, this.conteosClaves.clave.productoId).subscribe((data: backInter.timeLineGraficaCertificar) => {
    // console.log(data);

       let datas:any[]=[];
       let i=0;
       let labelsFechas:any[]=[];
       let valorMayor: any[]=[];
       let labelsFechasLine:any[]=[];
       let valorMayorLine: any[]=[];
     data.resultado.forEach(element => {
       let objeto={x:0, y:0,r:0};
       objeto.x=i;
       objeto.y=element.endUsers;
       objeto.r=6;
       datas.push(objeto);
       labelsFechas.push(element.fecha);
       valorMayor.push(element.endUsers);
    i++;
     });
     data.resultado.forEach(element => {
    labelsFechasLine.push(this.datePipe.transform(new Date(element.fecha),'d MMM y','+0000',this.idiomaActual));
       valorMayorLine.push(element.endUsers);

       i++;
     });
     this.lineChartData[0].data=valorMayorLine;
     this.lineChartLabels=labelsFechasLine;
     console.log(this.lineChartData);
     this.graficaValoresLine(labelsFechasLine);
       this.graficaValores(labelsFechas,valorMayor,labelsFechas.length);
       this.bubbleChartData[0].data = datas;
       console.log(this.bubbleChartData);
       this.datosEncontrados=true;
       this.timeLineGraficaCer = data;
       // console.log(this.timeLineGraficaCer);

        // this.cargandoFiltros=false;
      }, error => {
        console.log(error);
      });



    }

    timeLinePulse(){
      // let datos:any= {productoId: localStorage.getItem('productoID')};
      // console.log(datos);
     this.conteosService.getTimeLineGraficaPulseForaneo(this.conteosClaves.clave.empresaId, this.conteosClaves.clave.productoId).subscribe((data: backInter.timeLineGraficaCertificar) => {
    console.log(data);

       let datas:any[]=[];
       let i=0;
       let labelsFechas:any[]=[];
       let valorMayor: any[]=[];
       let labelsFechasLine:any[]=[];
       let valorMayorLine: any[]=[];
     data.resultado.forEach(element => {
       let objeto={x:0, y:0,r:0};
       objeto.x=i;
       objeto.y=element.endUsers;
       objeto.r=6;
       datas.push(objeto);
       labelsFechas.push(element.fecha);
       valorMayor.push(element.endUsers);
    i++;
     });

     data.resultado.forEach(element => {
       labelsFechasLine.push(this.datePipe.transform(new Date(element.fecha),'d MMM y','+0000',this.idiomaActual));
       valorMayorLine.push(element.endUsers);

       i++;
     });
     this.lineChartData[0].data=valorMayorLine;
     this.lineChartLabels=labelsFechasLine;
     console.log(this.lineChartData);
     this.graficaValoresLine(labelsFechasLine);

       this.graficaValores(labelsFechas,valorMayor,labelsFechas.length);
       this.bubbleChartData[0].data = datas;
       console.log(this.bubbleChartData);
       this.datosEncontrados=true;
       this.timeLineGraficaCer = data;
       // console.log(this.timeLineGraficaCer);

        // this.cargandoFiltros=false;
      }, error => {
        console.log(error);
      });
    }

    graficaValores(labelsFechas:any[],valorMayor:any[],maximoX: number){


     this.bubbleChartOptions = {
      responsive: true,
      tooltips: {
         callbacks: {
            label: function(t, d) {
               return  labelsFechas[t.xLabel] + ', Total:' + t.yLabel + '';
            }
         }
      },
      scales: {
        xAxes: [
          {
            ticks: {
              min: 0,
              max: maximoX,
              stepSize: 1,

              callback: function(value, index, values) {

                           return labelsFechas[index];
                       }
            }
          }
        ],
        yAxes: [
          {
            ticks: {
              min: 0,
              max: Math.max.apply(null, valorMayor)+(Math.max.apply(null, valorMayor)*.1),
            }
          }
        ]
      }
     };
   }



   graficaValoresLine(labelsFechasLine:any[]){
     this.lineChartOptions= {
         responsive: true,
         legend: {
      display: false,
    },
    tooltips: {
       callbacks: {
          label: function(t, d) {
             return 'Total:' + t.yLabel + '';
          }
       }
    },
         scales: {
           // We use this empty structure as a placeholder for dynamic theming.
           xAxes: [{}],
           yAxes: [
             // {
             //   id: 'y-axis-0',
             //   position: 'left',
             // },
             // {
             //   id: 'y-axis-1',
             //   position: 'right',
             //   gridLines: {
             //     // color: 'rgba(255,0,0,0.3)',
             //   },
             //   ticks: {
             //     // fontColor: 'red',
             //   }
             // }
           ]
         },
       };


   }

   infoExcel(){
     Swal.fire({
       title: this.mensajesTraducirTS.excel,
       didOpen: () => {
         Swal.showLoading()
       }
     });

     var wb = XLSX.utils.book_new();
     wb.Props = {
       Title: this.mensajesTraducirTS.titulo,
       Subject: this.mensajesTraducirTS.asunto,
       Author: this.mensajesTraducirTS.autor,
       CreatedDate: new Date()
     };
     wb.SheetNames.push(this.mensajesTraducirTS.hoja);
     // var ws_data = [['hello' , 'world']];  //a row with 2 columns
     var moment = require('moment');
     var ws_data = [
       [this.mensajesTraducirTS.nomempre,this.nombreEmpresaFinal],
       [this.mensajesTraducirTS.nomusuario,this.usuarioEmpresaFinal],
       [this.mensajesTraducirTS.nomprod,this.tipoProductoFinal+" "+this.fechaProducto],
       [this.mensajesTraducirTS.fechlanza,this.fechaLanzamiento],
       [this.mensajesTraducirTS.fechdesca,moment().format('l')],
       [this.mensajesTraducirTS.drestan,this.diasRestantes],
       [this.mensajesTraducirTS.totalcola,this.mensajesTraducirTS.totalfal,this.mensajesTraducirTS.totalcont,this.mensajesTraducirTS.totalpro,this.mensajesTraducirTS.reporte,this.mensajesTraducirTS.ranking],
       [this.totalUsers,this.totalUsers-this.endUsers,this.endUsers,this.porcentajeUsers+"%",this.totalUsers*85/100,this.resultadoRanking+"%" ]

     ];
     var ws = XLSX.utils.aoa_to_sheet(ws_data);
     XLSX.utils.book_append_sheet(wb, ws, this.mensajesTraducirTS.infogene);
     let data={productoId: this.conteosClaves.clave.productoId}
     switch (this.tipoProducto) {
       case '1':
       this.conteosService.getInfoDescargaExcelCertificarForaneo(data,this.conteosClaves.clave.empresaId).subscribe((data: backInter.getFullInfoExcel) => {
         console.log(data);
         if(data.success && data.array.length > 0){
           data.array.forEach( (nombre) =>{
             let hoja= [];
             let texto='PORTAL.EXCEL.FILTROSNAME.';
             this.translateSrv.get(texto+nombre.key).subscribe((res: string) => { texto = res; });
             hoja.push([
               this.mensajesTraducirTS.nomfilt,texto
             ]);
             hoja.push([
               this.mensajesTraducirTS.nomfilt,this.mensajesTraducirTS.totalcola,this.mensajesTraducirTS.totalfal,this.mensajesTraducirTS.totalcont,this.mensajesTraducirTS.totalpro

             ]);
             nombre.filtros.forEach(filtro => {
             let fila=[
               filtro.subfiltro,
               filtro.totalUsers,
               filtro.endUsers,
               (filtro.totalUsers-filtro.endUsers),
               filtro.porcentaje+"%",

             ]
             hoja.push(fila);
             });
             var ws = XLSX.utils.aoa_to_sheet(hoja);
            XLSX.utils.book_append_sheet(wb, ws, texto);
           });



              //  var ws = XLSX.utils.aoa_to_sheet(hoja);
              //  // wb.Sheets[this.mensajesTraducirTS.hoja] = ws;
              // XLSX.utils.book_append_sheet(wb, ws, nombre.key);
              // XLSX.utils.book_append_sheet(wb, ws, "sa");
              // XLSX.utils.book_append_sheet(wb, ws, "shsashdsk");
              // XLSX.utils.book_append_sheet(wb, ws, "shshzsdsk");
               var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

               var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
               var view = new Uint8Array(buf);  //create uint8array as viewer
               for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

               saveAs(new Blob([buf],{type:"application/octet-stream"}), this.mensajesTraducirTS.titulo+" "+this.nombreEmpresaFinal+'.xlsx');
               Swal.close();
               Swal.fire({
                 position: 'center',
                 icon: 'success',
                 title: 'Descarga Correctamente',
                 showConfirmButton: false,
                 timer: 1500
               })
     }
          }, error => {
       console.log(error);
       });
      break;
       case 'c1': case 'c2':  case 'c3':
       this.conteosService.getInfoDescargaExcelCertificarForaneo(data,this.conteosClaves.clave.empresaId).subscribe((data: backInter.getFullInfoExcel) => {
         console.log(data);
         if(data.success && data.array.length > 0){
           data.array.forEach( (nombre) =>{
             let hoja= [];
             let texto='PORTAL.EXCEL.FILTROSNAME.';
             this.translateSrv.get(texto+nombre.key).subscribe((res: string) => { texto = res; });
             hoja.push([
               this.mensajesTraducirTS.nomfilt,texto
             ]);
             hoja.push([
               this.mensajesTraducirTS.nomfilt,this.mensajesTraducirTS.totalcola,this.mensajesTraducirTS.totalfal,this.mensajesTraducirTS.totalcont,this.mensajesTraducirTS.totalpro

             ]);
             nombre.filtros.forEach(filtro => {
             let fila=[
               filtro.subfiltro,
               filtro.totalUsers,
               filtro.endUsers,
               (filtro.totalUsers-filtro.endUsers),
               filtro.porcentaje+"%",

             ]
             hoja.push(fila);
             });
             var ws = XLSX.utils.aoa_to_sheet(hoja);
            XLSX.utils.book_append_sheet(wb, ws, texto);
           });



              //  var ws = XLSX.utils.aoa_to_sheet(hoja);
              //  // wb.Sheets[this.mensajesTraducirTS.hoja] = ws;
              // XLSX.utils.book_append_sheet(wb, ws, nombre.key);
              // XLSX.utils.book_append_sheet(wb, ws, "sa");
              // XLSX.utils.book_append_sheet(wb, ws, "shsashdsk");
              // XLSX.utils.book_append_sheet(wb, ws, "shshzsdsk");
               var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

               var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
               var view = new Uint8Array(buf);  //create uint8array as viewer
               for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

               saveAs(new Blob([buf],{type:"application/octet-stream"}), this.mensajesTraducirTS.titulo+" "+this.nombreEmpresaFinal+'.xlsx');
               Swal.close();
               Swal.fire({
                 position: 'center',
                 icon: 'success',
                 title: 'Descarga Correctamente',
                 showConfirmButton: false,
                 timer: 1500
               })
     }
          }, error => {
       console.log(error);
       });
      break;
      case '2':
      this.conteosService.getInfoDescargaExcelMedirForaneo(data,this.conteosClaves.clave.empresaId).subscribe((data: backInter.getFullInfoExcel) => {
        console.log(data);
        if(data.success && data.array.length > 0){
          data.array.forEach( (nombre) =>{
            let hoja= [];
            let texto='PORTAL.EXCEL.FILTROSNAME.';
            this.translateSrv.get(texto+nombre.key).subscribe((res: string) => { texto = res; });
            hoja.push([
              this.mensajesTraducirTS.nomfilt,texto
            ]);
            hoja.push([
              this.mensajesTraducirTS.nomfilt,this.mensajesTraducirTS.totalcola,this.mensajesTraducirTS.totalfal,this.mensajesTraducirTS.totalcont,this.mensajesTraducirTS.totalpro

            ]);
            nombre.filtros.forEach(filtro => {
            let fila=[
              filtro.subfiltro,
              filtro.totalUsers,
              filtro.endUsers,
              (filtro.totalUsers-filtro.endUsers),
              filtro.porcentaje+"%",

            ]
            hoja.push(fila);
            });
            var ws = XLSX.utils.aoa_to_sheet(hoja);
           XLSX.utils.book_append_sheet(wb, ws, texto);
          });



             //  var ws = XLSX.utils.aoa_to_sheet(hoja);
             //  // wb.Sheets[this.mensajesTraducirTS.hoja] = ws;
             // XLSX.utils.book_append_sheet(wb, ws, nombre.key);
             // XLSX.utils.book_append_sheet(wb, ws, "sa");
             // XLSX.utils.book_append_sheet(wb, ws, "shsashdsk");
             // XLSX.utils.book_append_sheet(wb, ws, "shshzsdsk");
              var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

              var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
              var view = new Uint8Array(buf);  //create uint8array as viewer
              for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

              saveAs(new Blob([buf],{type:"application/octet-stream"}), this.mensajesTraducirTS.titulo+" "+this.nombreEmpresaFinal+'.xlsx');
              Swal.close();
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Descarga Correctamente',
                showConfirmButton: false,
                timer: 1500
              })
    }
         }, error => {
      console.log(error);
      });
     break;

       default:
         break;
     }


   }




selecTipoDePortal(){
  console.log(this.tipoPersonalSeleccionado);

  switch (this.tipoPersonalSeleccionado) {
    case 1:
    this.getConteosClaves();
      break;
    case 2:
    this.getConteosClavesEmpresa2();
    this.tipoPersonalSeleccionado=2;

      break;
    case 3:
    this.getConteosClavesVersion2();
      break;

    default:
      break;
  }

}

obtenerInfoCambioIdioma(){
  switch(this.tipoProducto){
    case "1":
    this.timeLineCertificar();
    break;
    case "7":
    this.timeLineCertificar();
    break;
    case "c1":
    this.timeLineCertificar();

    break;
    case "c2":
    this.timeLineCertificar();
    break;
    case "c3":
    this.timeLineCertificar();
    break;
    case "2":
    this.timeLineMedir();
    break;
    case "4":
    this.timeLinePulse();
    break;
    case "6":
    this.timeLineFocusArea();
    break;
    case "5": this.urlProducto = 'norm';
    this.calcularVigencia(this.conteosClaves.cierre);
    this.getFiltros();
    break;
    default: break;
    case "m1":
    this.timeLineMedir();

    break;
    case "m2":
    this.timeLineMedir();
    break;
    case "m3":
    this.timeLineMedir();
    break;
    case "m4":
    this.timeLineMedir();

    break;
    case "m5":
    this.timeLineMedir();

    break;
    case "m6":
    this.timeLineMedir();
    break;

  }
}





}
